import { ref, computed, onMounted, onUnmounted } from 'vue'

export function useMobileChecker() {
  // Initialize with real window width if client, otherwise 0
  const windowWidth = ref(typeof window !== 'undefined' ? window.innerWidth : 0)

  const updateWidth = () => {
    if (typeof window !== 'undefined') {
      windowWidth.value = window.innerWidth
    }
  }

  onMounted(() => {
    updateWidth()
    window.addEventListener('resize', updateWidth)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', updateWidth)
  })

  const isMobile = computed(() => windowWidth.value < 768)
  const isTablet = computed(() => windowWidth.value >= 768 && windowWidth.value < 1025)
  const isDesktop = computed(() => windowWidth.value >= 1025)

  return {
    windowWidth,
    isMobile,
    isTablet,
    isDesktop
  }
}





